import { useEffect } from "react";
import DragAndDrop from "../../../../components/dragAndDrop";
import { openPopUp } from "../../../../components/popUp";
import { useAppContext } from "../../../../context/appContext";
import { useDashboardContext } from "../../../../context/dashboardContext";
import { getApiUrl } from "../../../../data/api/apiManager";
import { PerformanceDTO, PerformanceDTOTypeEnum, PieceDTO } from "../../../../openapi-generated-client";
import { removeLastOccurrance } from "../../../../utils/arrayUtils";
import EditPieceAddPerformancePopUp from "./components/editPieceAddPerformancePopUp";
import EditPiecePerformanceElement from "./components/editPiecePerformanceElement";
import EditPieceStepAddButton from "./components/editPieceStepAddButton";

interface EditPiecePerformancesProps {
    piece: PieceDTO;
    setPiece: (piece: PieceDTO) => void;
    setStepMessage: (v: string) => void;
    audios: File[];
    setAudios: (audios: File[]) => void;
}

export default function EditPiecePerformances(props: EditPiecePerformancesProps) {

    function getMessage(data: PieceDTO) {
        for(const performance of data.performances) {
            if(((performance.performerName === undefined || performance.performerName === "") && (performance.performerId === undefined || performance.performerId <= -1)) || performance.link === undefined || performance.link === "") {
                return "You have to enter a performer and a link for all performances. Please check your performances.";
            }
        }
        return "";
    }

    useEffect(() => {
        props.setStepMessage(getMessage(props.piece));
    }, [props.piece]);

    const {appContext, sessionId} = useDashboardContext();
    const {assetController} = appContext;

    async function uploadAudioFile(file: File) {
        var body = new FormData();
        body.append('file', file);
        body.append('assetCreateDTO', new Blob([
                    JSON.stringify({
                        altText: file.name
                    })
                ], {
                    type: "application/json"
                }));
        const response = await fetch(getApiUrl("assets"), {
            method: "POST",
            headers: {
                "authorization": sessionId
            },
            body: body
        });
        if(response.status == 201) {
            const data = await response.json();
            props.setPiece({
                ...props.piece,
                performances: [...props.piece.performances, {
                    type: PerformanceDTOTypeEnum.Local,
                    performerName: "",
                    performerId: -1,
                    link: data.contentHash,
                    description: file.name
                }]
            })
        }
    }

    return <>
        <DragAndDrop name="Drop a performance audio file here" onUpload={async (files: File[]) => {
            for(const file of files) {
                await uploadAudioFile(file);
            }
        }}/>
        <h2>Performances</h2>
        <p className="quotation">Add performances of your piece.</p>
        <div className="element-list">
            {props.piece.performances.map((e, i) => {
                return <EditPiecePerformanceElement performance={e} setPerformance={(el: PerformanceDTO) => {
                    const newPerformances = [...props.piece.performances];
                    newPerformances[i] = el;
                    props.setPiece({...props.piece, performances: newPerformances});
                }} onDelete={() => {
                    console.log(e);
                    console.log(props.piece.performances);
                    props.setPiece({...props.piece, performances: removeLastOccurrance(props.piece.performances, e)});
                }}/>
            })}
        </div>
        <EditPieceStepAddButton onClick={() => {
            openPopUp(<EditPieceAddPerformancePopUp onFinish={(url: string, type: PerformanceDTOTypeEnum) => {
                props.setPiece({...props.piece, performances: [...props.piece.performances, {
                    type: type,
                    link: url,
                    performerId: -1,
                    performerName: "",
                    description: ""
                }]})
            }}/>)
        }}>Click to add a link to Youtube, Spotify or Soundcloud or Drag and Drop an MP3-file.</EditPieceStepAddButton>
        
    </>;

}